export default __webpack_public_path__ + "static/media/bgVideo.7a8e5b7d.mp4";